<div class="tabMenu body-bold" [class.header]="header()">
  <nz-tabs
    [nzSelectedIndex]="activeTab()"
    [class.noSelection]="activeTab() < 0"
    [nzTabPosition]="header() ? 'top' : 'bottom'"
    [nzCentered]="true"
    nzSize="large"
    [nzLinkExact]="false"
  >
    @if (!navigation()) {
      <nz-tab>
        <a *nzTabLink nz-tab-link
          ><i nz-icon nzType="icons:navigation"></i
          >{{ i18n.langString("navigation") }}</a
        >
      </nz-tab>
    }
    @if (!!navigation()) {
      <nz-tab>
        <a *nzTabLink nz-tab-link [routerLink]="['/home']"
          ><i nz-icon nzType="icons:navigation"></i
          >{{ i18n.langString("navigation") }}</a
        >
      </nz-tab>
    }
    @if (cfg.appName === "em") {
      <nz-tab>
        <a *nzTabLink nz-tab-link [routerLink]="['/notifications']">
          @if (notificationCount() === 0 || activeTab() === 1) {
            <i nz-icon nzType="icons:bell"></i>
          }
          @if (notificationCount() > 0 && activeTab() !== 1) {
            <nz-badge
              [nzCount]="
                numEquipmentNotifications() + numEdgeDeviceNotifications()
              "
              [nzStyle]="{ backgroundColor: '#E1000F' }"
              nzStandalone
            ></nz-badge>
          }
          <span class="notification">{{
            i18n.langString("notifications")
          }}</span>
        </a>
      </nz-tab>
    }
    @if (header()) {
      <nz-tab>
        <a *nzTabLink nz-tab-link [routerLink]="['/settings']"
          ><i nz-icon nzType="icons:more-information"></i
          >{{ i18n.langString("settings") }}</a
        >
      </nz-tab>
    }
  </nz-tabs>
</div>
